import { Modal } from '@platform/components';

type SaveAndExitModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  isRep?: boolean;
};
export const SaveAndExitModal = (props: SaveAndExitModalProps) => {
  const { isOpen, closeModal, isRep } = props;

  const exit = () => {
    window.location.href = import.meta.env.VITE_API_HOST + '/login/logout';
  };

  return (
    <Modal
      variant='dialog'
      title='Almost there!'
      isOpen={isOpen}
      headerDivision='divider'
      onClose={closeModal}
      ignoreExtraPadding={true}
      primaryCTA={{
        text: 'Continue application',
        callback: closeModal,
      }}
      secondaryCTA={{
        text: 'Save & exit',
        callback: exit,
      }}
    >
      <div className='flex flex-col gap-4 w-full text-center h-full'>
        <div>The whole application takes under {isRep ? 20 : 10} minutes.</div>
        <div>If you exit now, your progress will be saved. Just log back in to continue later.</div>
      </div>
    </Modal>
  );
};
